var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3,23.5c-1.3,0-2.7-0.4-3.9-1.1c-4.8-2.9-8.9-7-11.8-11.8c-1.3-2.2-1.5-4.9-0.3-7c0.6-1.2,1.6-2.2,2.9-2.8 c1-0.5,2.1-0.3,2.9,0.5l3.4,3.4c1,1,1,2.6,0,3.6L9.6,9.1l5.3,5.3l0.9-0.9c1-1,2.6-1,3.6,0l3.4,3.4c0.8,0.8,1,2,0.5,2.9 c-0.6,1.2-1.6,2.2-2.8,2.9C19.4,23.2,18.4,23.5,17.3,23.5L17.3,23.5z M5.3,3C4.5,3.4,3.9,4,3.5,4.8C2.8,6.1,2.9,7.9,3.7,9.3 c2.7,4.5,6.5,8.3,11,11c1.4,0.9,3.2,1,4.5,0.3c0.8-0.4,1.4-1,1.8-1.8l-3.4-3.4l-0.9,0.9c-1,1-2.6,1-3.6,0l-5.3-5.3c-1-1-1-2.6,0-3.6 l0.9-0.9L5.3,3z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ff8539867e973625512ab51a8016105f.svg";
export { ForwardRef as ReactComponent };